'use client'

import { useState } from 'react'
import { useGetEmployeesSWR } from '@/lib/employee/employee-swr'
import { deleteEmployeeAPI } from '@/lib/employee/Employee'
import { className } from '@/components/common/styles'

// @@TODO: Not fully implemented: all buttons use deleteEmployee() directly
const Employee = () => {
  const [id, setId] = useState(174) // 0
  const result = useGetEmployeesSWR('/api/get-employee')

  const deleteAPI = () => {
    const wrapper = async () => {
      try {
        const data = await deleteEmployeeAPI(id)
        console.log('deleteAPI(): data=', data)
        if (!data) {
          console.log('deleteAPI(): error')
        }
      } catch (error) {
        console.log('deleteAPI() error:', error)
      }
    }
    // NOTE: Intentionally not awaited.
    void wrapper()
  }

  // @@TODO: Stub
  const deleteSWR = () => {
    throw new Error('Not implemented')
  }

  // @@TODO: Stub
  const deleteSWRAPI = () => {
    throw new Error('Not implemented')
  }

  return (
    <>
      <h1 className="text-2xl font-bold">Delete (swr)</h1>
      <div>
        <div>
          <label>
            id:{' '}
            <input
              name="selectedId"
              type="string"
              value={id}
              onChange={(e) => {
                console.log('id=', e.target.value)
                setId(Number.parseInt(e.target.value, 10))
              }}
              className="rounded-xs border border-gray-400 dark:border-gray-600 bg-gray-100 dark:bg-gray-900 text-black dark:text-white"
            />
          </label>
        </div>
        <b>From client</b>
        <button type="button" className={className} onClick={deleteAPI}>
          delete (API)
        </button>
        <span> </span>
        <button type="button" className={className} onClick={deleteSWR}>
          delete swr
        </button>
        <span> </span>
      </div>
      <div>
        <b>Through API</b>
        <button type="button" className={className} onClick={deleteSWRAPI}>
          delete swr api
        </button>
      </div>
    </>
  )
}

export default Employee
